
define('text!Amasty_Xsearch/template/components/loader.html',[],function () { return '<section class="amsearch-loader-block" data-bind="visible: loading"></section>\n';});

